import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm, useNotify, useStore } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import EditForm from "./EditForm";

const STORE_KEY = "internshipIndividualCycleSchedule.filters";

const EditScheduleIndividualCycle = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  const transform = data => ({
    internshipSessionId: data.internshipSessionId,
    planId: data.planId,
    disciplineId: data.disciplineId,
    fromDate: data.fromDate,
    toDate: data.toDate,
    slots: data.slots,
  });

  return (
    <>
      <Edit
        title="Редакция на индивидуален цикъл"
        actions={<BackButtonToolbar />}
        transform={transform}
        mutationMode="pessimistic"
        mutationOptions={{
          onError: e => {
            handleConflictError(e);
            const errorMessage = e.message || errorMessages[e.errorCode];
            notify(errorMessage, { type: "error" });
          },
        }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
            planId: filters?.planId,
          }}
        >
          <EditForm filters={filters} />
        </SimpleForm>
      </Edit>
      <ConflictErrorDialog />
    </>
  );
};

export default EditScheduleIndividualCycle;
